if (module.hot) {
  module.hot.accept();
}
require('./custom');

// this import is required for bootstrap
import 'bootstrap';

